import { Dialog } from "@mui/material";

interface Props {
  open: boolean;
  onClosingJobPostModal: () => void;
}

function JobPostModal(props: Props) {
  const { open, onClosingJobPostModal } = props;

  return (
    <Dialog
      open={open}
      onClose={onClosingJobPostModal}
      fullWidth={true}
      maxWidth="xs"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    >
      <div
        style={{
          padding: 15,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          style={{ width: "400px", maxHeight: "450px" }}
          src="vacancyposter.jpg"
          alt="image"
        />
      </div>
    </Dialog>
  );
}

export default JobPostModal;
